import { render, staticRenderFns } from "./AppBarApplications.vue?vue&type=template&id=1b9c5e7c"
import script from "./AppBarApplications.vue?vue&type=script&lang=js"
export * from "./AppBarApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports